import { service } from '@ember/service';
import AuthenticatedRoute from 'eflex/util/authenticated-route';
import WieSettings from 'eflex/constants/work-instructions/wie-settings';

export default class WorkInstructionsIndexRoute extends AuthenticatedRoute {
  @service store;
  @service workInstructionRepo;

  queryParams = {
    folderId: {
      refreshModel: true,
    },
  };

  model(params) {
    if (params.folderId) {
      return this.store.findRecord('work-instruction-folder', params.folderId);
    } else {
      return null;
    }
  }

  afterModel() {
    return this.store.query('work-instruction', { recentOnly: true });
  }

  setupController(controller, workInstructionFolder) {
    const props = {
      selectedFolder: workInstructionFolder,
    };

    if (this.workInstructionRepo.userIsApproverDeployerOnly()) {
      Object.assign(props, {
        currentLibraryView: WieSettings.libraryViews.APPROVAL,
        editorControlsCollapsed: true,
      });
    }

    Object.assign(controller, props);
  }

  resetController(controller) {
    controller.currentLibraryView = WieSettings.libraryViews.THUMB;
  }
}
